import React from 'react';
import { string, number } from 'prop-types';

import * as helpers from './helpers';

const ViewDetailsIcon = ({ color, fillOpacity, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <path
      fill={color}
      stroke={color}
      strokeWidth={0.3}
      fillRule="evenodd"
      clipRule="evenodd"
      fillOpacity={fillOpacity}
      d="M8.3125 6.99887H3.0625C2.821 6.99887 2.625 7.19487 2.625 7.43637C2.625 7.67831 2.821 7.87387 3.0625 7.87387H8.3125C8.554 7.87387 8.75 7.67831 8.75 7.43637C8.75 7.19487 8.554 6.99887 8.3125 6.99887ZM8.3125 9.62387H3.0625C2.821 9.62387 2.625 9.81943 2.625 10.0614C2.625 10.3033 2.821 10.4989 3.0625 10.4989H8.3125C8.554 10.4989 8.75 10.3033 8.75 10.0614C8.75 9.81943 8.554 9.62387 8.3125 9.62387ZM8.75 3.49887C8.267 3.49887 7.875 3.10687 7.875 2.62387V0.873871L10.5 3.49887H8.75ZM10.5 12.2489C10.5 12.7319 10.108 13.1239 9.625 13.1239H1.75C1.267 13.1239 0.875 12.7319 0.875 12.2489V1.74887C0.875 1.26587 1.267 0.873871 1.75 0.873871H6.98775C6.97988 1.92168 7 2.62387 7 2.62387C7 3.59031 7.78356 4.37387 8.75 4.37387H10.5V12.2489ZM7.875 -0.00112904V0.0111209C7.819 0.0111209 7.58537 -0.0103165 7 -0.00112904H1.75C0.783562 -0.00112904 0 0.782433 0 1.74887V12.2489C0 13.2153 0.783562 13.9989 1.75 13.9989H9.625C10.5914 13.9989 11.375 13.2153 11.375 12.2489V3.49887L7.875 -0.00112904Z"
    />
  </svg>
);

ViewDetailsIcon.propTypes = {
  fillOpacity: number,
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

ViewDetailsIcon.defaultProps = {
  fillOpacity: 0.4,
  ...helpers.getDefaultIconDimensionsProps(12, 15),
};

export default ViewDetailsIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/view-details.js